module.exports = __webpack_public_path__ + "static/img/title.ef07c30.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/title.jpg
// module id = RzqU
// module chunks = 1